<template>
    <div class="components-container" id="mobileViewPort">
        <div id="mobileMode">
            <div id="titleArea">
                <div class="titleText">场地申请</div>
                <div class="titleButton">
                    <el-button class="custom-el-button" type="primary" @click="showHomePage">
                        <i class="el-icon-s-home"></i> 首页
                    </el-button>
                </div>
            </div>
            <div id="queryArea">
                <div class="filter-container">
                    <div class="formItem">
                        <el-input v-model="queryForm.SiteName" @keyup.enter.native="handleFilter" style="width: 200px" placeholder="场地名称" clearable>
                        </el-input>
                        <el-select v-model="queryForm.AuditState" filterable placeholder="审核状态" style="width:120px" clearable>
                            <el-option v-for="item in auditInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="formItem text-center">
                        <el-button @click="handleFilter" type="gray"><i class="el-icon-search"></i> 查询</el-button>
                        <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i> 重置</el-button>
                        <el-button @click="queryDialogVisible = true" type="primary"><i class="el-icon-more"></i> 更多</el-button>
                        <el-button @click="addRec" type="success"><i class="el-icon-circle-plus-outline"></i> 申请</el-button>
                    </div>
                </div>
            </div>

            <!-- 搜索内容弹框 -->
            <el-dialog id="queryDialog" class="formDialog" title="查询信息" width="90%" :visible.sync="queryDialogVisible">
                <el-row>
                    <el-input v-model="queryForm.SiteName" @keyup.enter.native="handleFilter" style="width: 100%" placeholder="场地名称" clearable>
                    </el-input>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.SiteType" filterable placeholder="场地类型" style="width:100%" clearable>
                        <el-option v-for="item in cdlxInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.AuditState" filterable placeholder="审核状态" style="width:100%" clearable>
                        <el-option v-for="item in auditInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-row>
                <div slot="footer" class="dialog-footer text-center">
                    <el-button type="gray" @click="handleFilter">查 询</el-button>
                    <el-button style="margin-left: 10px;" type="gray" @click="handleReset">重 置</el-button>
                    <el-button style="margin-left: 10px;" @click="queryDialogVisible = false">取 消</el-button>
                </div>
            </el-dialog>

            <div id="loadingMask" class="maskStyle">
                <div class="maskFont">场地申请保存中，请稍后...</div>
            </div>

            <div id="listArea" @scroll="handleScroll">
                <div v-if="tableData==null || tableData.length==0" class="cardTips">没有场地申请信息</div>
                <div class="cardMain" v-for="(item,index) in tableData" :key="index">
                    <div class="cardText">
                        <p><label for="">场地名称：</label>{{ item.siteName }}</p>
                        <p><label for="">场地类型：</label>{{ item.siteType }}</p>
                        <p><label for="">可容纳人数：</label>{{ item.siteCapacity }}</p>
                        <p><label for="">提交状态：</label>{{ item.submitState }}</p>
                        <p><label for="">审核状态：</label>{{ item.auditState }}</p>
                        <div class="auditStateImg">
                            <img :src="loadStateImg(item)" alt="">
                        </div>
                    </div>
                    <div class="cardInput" >
                        <el-button v-if="item.auditState == '-1'" size="small" @click="modRec(item);" type="warning">
                            <i class="el-icon-edit"></i>&nbsp;编辑
                        </el-button>
                        <el-button v-if="item.submitState == '0'" size="small" @click="delRec(item);" type="danger">
                            <i class="el-icon-delete"></i>&nbsp;删除
                        </el-button>
                        <el-button v-if="item.auditState !='-1' && item.auditAuth=='0'" size="small" @click="showDetailInfo(item);" type="info">
                            <i class="el-icon-tickets"></i>&nbsp;详情
                        </el-button>
                        <el-button v-if="item.auditAuth == '1'" size="small" @click="auditRec(item);" type="primary">
                            <i class="el-icon-edit-outline"></i>&nbsp;审核
                        </el-button>
                        <el-button v-if="item.auditState != '-1'" size="small" @click="showAuditList(item);">
                            <i class="el-icon-document-copy"></i>&nbsp;审核信息
                        </el-button>
                    </div>
                </div>
                <div v-if="total>2 && total>tableData.length" id="loadingTips">
                    <i class="el-icon-loading"></i>&nbsp;信息加载中，请稍后...
                </div>
            </div>

            <el-dialog id="mainDialog" class="formDialog" :title="dialogTitle" :visible.sync="dialogVisible" @closed="closeDialog" width="90%">
                <el-scrollbar id="mainDialogScroll" ref="mainDialogScroll">
                    <el-form :model="curdForm" ref="curdForm" label-width="90px" label-position="left" width="100%" :rules="curdRules">
                        <!-- 新建，编辑 -->
                        <div v-if="editType=='new' || editType=='edit'">
                            <el-form-item label="学年学期" prop="xnxqbm">
                                <el-select v-model="curdForm.xnxqbm" filterable placeholder="请选择学年学期" style="width:90%;" @change="selectChange" :disabled="auditDisabled">
                                    <el-option v-for="item in xnxqInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="场地名称" prop="siteCode">
                                <el-select v-model="curdForm.siteCode" filterable :placeholder="siteComboTips" style="width:90%;" :disabled="siteComboDisable || disabled">
                                    <el-option v-for="item in siteInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="日期时间">
                                    <el-button v-if="auditDisabled == false" @click="queryDateTime" type="primary" size="mini" :disabled="disabled"><i class="el-icon-search"></i>&nbsp;可用时间查询</el-button>
                            </el-form-item>

                            <div>
                                <el-button v-if="auditDisabled == false" @click="addDateTime" type="success" size="mini" :disabled="disabled"><i class="el-icon-circle-plus-outline"></i>&nbsp;添加</el-button>
                                <el-button v-if="auditDisabled == false" @click="editDateTime" type="warning" size="mini" :disabled="disabled"><i class="el-icon-edit"></i>&nbsp;编辑</el-button>
                                <el-button v-if="auditDisabled == false" @click="delDateTime" type="danger" size="mini" :disabled="disabled"><i class="el-icon-delete"></i>&nbsp;删除</el-button>
                            </div>

                            <el-table :data="dateTimeData" :height="220" ref="dateTimeTable" v-loading.body="tableLoading" :header-cell-style="{'text-align':'center'}"
                                element-loading-text="信息加载中" stripe border fit highlight-current-row style="width:95%;margin-top:10px;" @row-click="rowClickDateTime">
                                <el-table-column label="申请日期" prop="applyDate" align="center" min-width="30%"></el-table-column>
                                <el-table-column label="节次" prop="useTime" :formatter="timeFormatter" align="center" min-width="50%"></el-table-column>
                            </el-table>

                            <el-form-item label="使用说明" prop="useDescription">
                                <el-input v-model="curdForm.useDescription" placeholder="请填写使用说明" autoComplete="on" type="textarea" style="width:90%;"
                                    :rows="3" show-word-limit maxlength="500" :disabled="auditDisabled"></el-input>
                            </el-form-item>
                            <el-form-item label="其它要求" prop="otherRequire">
                                <el-input v-model="curdForm.otherRequire" placeholder="请填写其它要求" autoComplete="on" type="textarea" style="width:90%;"
                                    :rows="3" show-word-limit maxlength="500" :disabled="auditDisabled"></el-input>
                            </el-form-item>
                        </div>

                        <!-- 场地申请详情 -->
                        <div v-if="editType=='audit' || editType=='show'" style="width:96%;">
                            <el-form-item label="学年学期" prop="xnxqmc">
                                {{ curdForm.xnxqmc }}
                            </el-form-item>

                            <el-form-item label="场地名称" prop="siteName" style="width:96%;">
                                {{ curdForm.siteName }}
                            </el-form-item>

                            <el-table :data="dateTimeData" :height="220" ref="dateTimeTable" v-loading.body="tableLoading" :header-cell-style="{'text-align':'center'}"
                                element-loading-text="信息加载中" stripe border fit highlight-current-row style="width:96%;margin-top:10px;" @row-click="rowClickDateTime">
                                <el-table-column label="申请日期" prop="applyDate" align="center" min-width="30%"></el-table-column>
                                <el-table-column label="节次" prop="useTime" :formatter="timeFormatter" align="center" min-width="50%"></el-table-column>
                            </el-table>

                            <el-form-item label="使用说明" prop="useDescription" style="width:96%;">
                                {{ curdForm.useDescription }}
                            </el-form-item>

                            <el-form-item label="其它要求" prop="otherRequire" style="width:96%;">
                                {{ curdForm.otherRequire }}
                            </el-form-item>
                        </div>
                    </el-form>

                </el-scrollbar>

                <div v-if="operateButtonVisible" slot="footer" class="dialog-footer text-center">
                    <el-button v-if="auditDisabled == false && editType!='show'" type="primary" :loading="formSubmiting" @click="saveRec()">保 存</el-button>
                    <el-button v-if="auditDisabled == false && editType!='show'" type="warning" :loading="formSubmiting" @click="submitRec()">提 交</el-button>
                    <el-button v-if="auditDisabled == true && editType!='show'"  type="warning" :loading="formSubmiting" @click="auditOption();">审核意见</el-button>
                    <el-button v-if="editType!='show'" @click="dialogVisible = false">取 消</el-button>
                </div>
            </el-dialog>

            <!-- 审核dialog -->
            <el-dialog :title="detailDialogTitle" class="formDialog xsyjDialog" :visible.sync="detailDialogVisible" v-if="detailDialogVisible" width="90%">
                <div style="margin-top:10px;height:160px;">
                    <audit ref="audit" :key="timer" :itemCode="queryForm.itemCode" :relatedCode="selectRowData.id" :auditLevel="curdForm.auditLevel"
                        @auditCallback="auditCallback"></audit>
                </div>
            </el-dialog>

            <el-dialog class="formDialog" title="审核信息" :visible.sync="auditListDialogVisible" v-if="auditListDialogVisible" width="90%" top="150px">
                <div style="height:550px;">
                    <auditList ref="auditList" :relatedCode="selectRowData.id" :listHeight="450"></auditList>
                </div>
            </el-dialog>

        </div>

        <el-dialog :title="weekslotTitle" :visible.sync="dateTimeDialog" width="90%" top="25vh" :before-close="handleDateTimeDialogClose" :close-on-click-modal="false" append-to-body>
            <el-form class="small-space" :model="dateTimeForm" :rules="dateTimeRule" ref="dateTimeForm" label-position="left" label-width="80px" style='width: 100%; margin-left:0px;'>
                <el-form-item label="申请日期" prop="applyDate">
                    <el-date-picker type="date" placeholder="开始日期" v-model="dateTimeForm.applyDate" value-format="yyyy-MM-dd" style="width:100%;" @change="checkDate"></el-date-picker>
                </el-form-item>
                <el-form-item label="节次" prop="useTime">
                    <el-select v-model="dateTimeForm.useTime" placeholder="请选择节次" class="input-full" style="width:100%;" multiple clearable>
                        <el-option v-for="(item, index) in timeslotInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="formSubmiting" @click="submitDateTime">确 定</el-button>
                <el-button @click="handleDateTimeDialogClose" >取 消</el-button>
            </div>
        </el-dialog>

        <el-dialog :title="dateTimeTitle" :visible.sync="dateTimeDialogVisible" v-if="dateTimeDialogVisible" width="90%" top="120px">
            <div style="height:510px;">
                <siteQueryTime ref="queTime" :selectedXnxqbm="curdForm.xnxqbm" :selectedSiteCode="curdForm.siteCode" :listHeight="500"></siteQueryTime>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { globalConfig } from 'static/config'
    import { confirmMsg, showNotify } from 'utils/message';
    import audit from 'views/mobile/audit.vue';
    import auditList from 'views/mobile/auditList.vue';
    import siteQueryTime from 'views/mobile/siteQueryTime.vue';

    export default {
        components: {
            audit,
            auditList,
            siteQueryTime,
        },
        data() {
            return {
                comboData: {
                    changeCode: null,
                    major: null,
                    class: null,
                },
                queryForm: {
                    pageNum: 1,
                    rowNum: 10,
                    Id: null,
                    SiteName: null,
                    SiteType: null,
                    AuditState: '',
                    StartTime: null,
                    EndTime: null,
                },
                tableData: [],
                currentPage: 1,
                limit: 10,
                total: null,
                tableLoading: true,
                selectRowData: null,
                selectRowDateTime: null,
                mainTableHeight: 500,
                dialogTitle: "",
                dialogVisible: false,
                fieldVisible: false,
                schoolVisible: false,
                majorVisible: false,
                classVisible: false,
                students: [],
                stuInfo: null,
                curdForm: {
                    id: '',
                    xnxqbm: '',
                    xnxqmc: '',
                    siteCode: '',
                    siteName: '',
                    useDescription: '',
                    otherRequire: '',
                    submitState: '',
                    auditState: '',
                    auditLevel: '',
                    auditAuth: '',
                },
                curdRules: {
                    xnxqbm: [{required: true, message: "请选择学年学期", trigger: ["blur", "change"],}],
                    siteCode: [{required: true, message: "请选择申请场地", trigger: ["blur", "change"],}],
                    useDescription: [{required: true, message: "请填写使用说明", trigger: ["blur"],}],
                },
                formSubmiting: false,
                detailDialogTitle: '',
                detailDialogTop: '150px',
                detailDialogVisible: false,
                auditAreaVisible: false,
                auditListDialogVisible: false,
                auditParam: null,

                xnxqInfo: [],//学年学期
                siteInfo: [], //场地信息
                auditInfo: [], //审核状态
                timeslotInfo: [], //时间段
                cdlxInfo: [], //场地类型
                weekslotTitle: "",
                disabled: true,
                auditDisabled: false,
                dateTimeData: [], //日期使用时间
                dateTimeDialog: false,
                dateTimeForm:{
                    applyDate: null,
                    useTime: null,
                },
                dateTimeRule: {
                    applyDate: [{required: true, message: "请选择日期",trigger: ["blur"],}],
                    useTime: [{required: true, message: "请选择节次", trigger: ["blur"],}],
                },
                editType: null,
                editTimeType: null,
                editapplyDate: null,
                edituseTime: null,
                auditLevel: null,
                xgbh: null,
                numarray: [],
                totalLevel: null,
                dateTimeTitle: '',
                dateTimeDialogVisible: false,
                siteComboDisable: true,
                siteComboTips: '请先选择学年学期',

                queryDialogVisible: false,
                operateButtonVisible: true,
            };
        },
        mounted() {
            this.auditInfo = [{"comboValue":"0","comboName":"未提交"},{"comboValue":"1","comboName":"待审核"},{"comboValue":"4","comboName":"审核中"},{"comboValue":"2","comboName":"审核通过"},{"comboValue":"3","comboName":"审核驳回"}];
            this.numarray = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
            this.initOption();
            this.queryAuditParam();
        },
        methods: {
            showHomePage(){
                this.$router.push('/m/wx/home');
            },
            handleScroll(){
                if(this.checkVisible() && !this.tableLoading && this.total>this.tableData.length){
                    this.currentPage++;
                    this.queryList();
                }
            },
            checkVisible() {
                const ele = document.getElementById('loadingTips');
                if(ele){
                    let rect = ele.getBoundingClientRect();
                    //获取当前浏览器的视口高度，不包括工具栏和滚动条
                    //document.documentElement.clientHeight兼容 Internet Explorer 8、7、6、5
                    let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
                    //bottom top是相对于视口的左上角位置
                    //bottom大于0或者top-视口高度小于0可见
                    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
                }else{
                    return false;
                }
            },
            scrollToTop(){
                const ele = document.getElementById('listArea');
                if(ele){
                    ele.scrollTop = 0;
                }
            },
            loadStateImg(row){
                let str = "";
                if(row.auditState === '0'){//未提交
                    return require('image/mobile/auditState/wtj.png');
                }else if(row.auditState === '1'){//待审核
                    return require('image/mobile/auditState/dsh.png');
                }else if(row.auditState === '4'){//审核中
                    return require('image/mobile/auditState/shz.png');
                }else if(row.auditState === '2'){//审核通过
                    return require('image/mobile/auditState/tg.png');
                }else if(row.auditState === '3'){//审核驳回
                    return require('image/mobile/auditState/bh.png');
                }
            },
            restoreScroll(){
                this.$nextTick(() => {
                    this.$refs.mainDialogScroll.wrap.scrollTop = 0;
                });
            },
            submitStateFormatter(row){
                return row.submitState === '1' ? '已提交' : '未提交';
            },
            auditStateFormatter(row){
                let str = '';
                if(row.auditState === '0'){
                    str = '未提交';
                }else if(row.auditState === '1'){
                    str = '待审核';
                }else if(row.auditState === '4'){
                    str = '审核中';
                }else if(row.auditState === '2'){
                    str = '审核通过';
                }else if(row.auditState === '3'){
                    str = '审核驳回';
                }
                return str;
            },
            //审状态列样式处理
            handleCellStyle({row, column, rowIndex, columnIndex}){
                let cellStyle;

                if(columnIndex === 5){
                    switch (row.auditState) {
                        case '2':
                            cellStyle = 'color: #00FF40 !important;';
                            break;
                        case '3':
                            cellStyle = 'color: #FE2E2E !important;';
                            break;
                        default:
                            cellStyle = '';
                    }

                    return cellStyle;
                }
            },
            queryList() {
                this.tableLoading = true;
                this.queryForm.pageNum = this.currentPage;
                this.queryForm.rowNum = this.limit;

                this.$api.teachingSiteManage.teachingSiteApply.list({
                    data: this.queryForm,
                }).then((response) => {
                    this.total = response.data.data.total;
                    this.tableData = response.data.data.list;
                    this.tableLoading = false;

                    if(this.tableData.length>0){
                        this.totalLevel = this.tableData[0].totalLevel;
                    }
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            handleFilter() {
                this.scrollToTop();
                this.tableData.length = 0;
                this.currentPage = 1;
                this.queryList();
                this.queryDialogVisible = false;
            },
            handleReset() {
                this.limit = 10;
                this.currentPage = 1;
                this.queryForm.SiteName = null;
                this.queryForm.SiteType = null;
                this.queryForm.AuditState = '';
                this.tableLoading = false;
                this.queryList();
            },
            handlePageChange(val) {
                this.currentPage = val;
                this.queryList();
            },
            handleCurrentChange(val) {
               this.selectRowData = val;
            },
            handleSizeChange(val) {
                this.limit = val;
                this.currentPage = 1;
                this.queryList();
            },
            initOption() {
                const paramMap = {
                    'name': 'combo_Info'
                }
                this.$api.teachingSiteManage.teachingSiteApply.initOption({
                    data: paramMap
                }).then(response => {
                    this.xnxqInfo = response.data.data.xnxq;
                    this.cdlxInfo = response.data.data.cdlx;
                    this.disabled = true;
                    //alert(JSON.stringify(response.data.data));
                }).catch(error => {
                    console.log(error);
                });
            },
            siteOption() {
                const paramMap = {
                    'Xnxqbm': this.curdForm.xnxqbm,
                }
                this.$api.teachingSiteManage.teachingSiteApply.siteOption({
                    data: paramMap
                }).then(response => {
                    this.siteInfo = response.data.data.site;
                    if(this.editType=="new" || this.editType=="edit"){
                        this.disabled = false;
                    }else{
                        this.disabled = true;
                    }
                    //alert(JSON.stringify(response.data.data));
                }).catch(error => {
                    console.log(error);
                });
            },
            timeslotOption(xnxqbm) {
                const paramMap = {
                    'Xnxqbm': xnxqbm,
                }
                this.$api.teachingSiteManage.teachingSiteInfo.timeslotOption({
                    data: paramMap
                }).then(response => {
                    this.timeslotInfo = response.data.data.timeslot;
                }).catch(error => {
                    console.log(error);
                });
            },
            querySearchStu(queryString, cb){
                let students = this.students;
                let results = queryString ? students.filter(this.createFilter(queryString)) : students;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (student) => {
                    return (student.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
                };
            },
            handleSelectStu(item){
                this.curdForm.stuCode = item.stuCode;
                this.curdForm.stuName = item.stuName;
                this.curdForm.oriMajorCode = item.majorCode;
                this.curdForm.oriMajorName = item.majorName;
                this.curdForm.oriClassCode = item.classCode;
                this.curdForm.oriClassName = item.className;
            },
            clearSelectStu(){
                document.activeElement.blur();
            },
            //选择学期
            selectChange(term){
                if(term != ''){
                   this.siteComboDisable = false;
                   this.siteComboTips = '请选择场地名称';
                }

                this.siteOption();
                this.timeslotOption(term);
            },
            rowClickDateTime(row){
                this.selectRowDateTime = row;
            },
            addDateTime(){
                if (this.curdForm.xnxqbm == '') {
                    this.$message({
                        title: '提示',
                        message: '请先选择学期!',
                        type: 'warning',
                        duration: 2000,
                    });
                    return;
                }
                if (this.curdForm.siteCode == '') {
                    this.$message({
                        title: '提示',
                        message: '请先选择场地!',
                        type: 'warning',
                        duration: 2000,
                    });
                    return;
                }
                this.editTimeType = "add";
                this.weekslotTitle = "新建";
                this.dateTimeDialog = true;
            },
            editDateTime(){
                if (this.selectRowDateTime == null) {
                    this.$message({
                        title: '提示',
                        message: '请先选择一条记录!',
                        type: 'warning',
                        duration: 2000,
                    });
                    return;
                }
                this.editTimeType = "edit";
                this.weekslotTitle = "编辑";
                this.dateTimeForm.applyDate = this.selectRowDateTime.applyDate;
                this.dateTimeForm.useTime = this.useTimeFormatter(this.selectRowDateTime.useTime).split(",");
                this.editapplyDate = this.selectRowDateTime.applyDate;
                this.edituseTime = this.selectRowDateTime.useTime;
                this.dateTimeDialog = true;
            },
            delDateTime(){
                if (this.selectRowDateTime == null) {
                    this.$message({
                        title: '提示',
                        message: '请先选择一条记录!',
                        type: 'warning',
                        duration: 2000,
                    });
                    return;
                }
            },
            queryDateTime(){
                if (this.curdForm.xnxqbm == '') {
                    this.$message({
                        title: '提示',
                        message: '请先选择学期!',
                        type: 'warning',
                        duration: 2000,
                    });
                    return;
                }
                if (this.curdForm.siteCode == '') {
                    this.$message({
                        title: '提示',
                        message: '请先选择场地!',
                        type: 'warning',
                        duration: 2000,
                    });
                    return;
                }

                let xnxqmc = "";
                let cdmc = "";
                for(let i=0;i<this.xnxqInfo.length;i++){
                    if(this.curdForm.xnxqbm == this.xnxqInfo[i].comboValue){
                        xnxqmc = this.xnxqInfo[i].comboName;
                    }
                }
                for(let i=0;i<this.siteInfo.length;i++){
                    if(this.curdForm.siteCode == this.siteInfo[i].comboValue){
                        cdmc = this.siteInfo[i].comboName;
                    }
                }
                this.dateTimeTitle = cdmc;
                this.dateTimeDialogVisible = true;
            },
            submitDateTime(){
                this.$refs.dateTimeForm.validate(valid => {
                    if(valid){
                        //排序，整理上课时间
                        this.dateTimeForm.useTime.sort(function (a,b){
                            return a-b;
                        });

                        let flag = false;
                        for(let i=0;i<this.dateTimeData.length;i++){
                            if(this.dateTimeForm.applyDate == this.dateTimeData[i].applyDate){
                                /* if(this.editTimeType=="add"){
                                    flag = this.checkTimeRepeat(this.useTimeFormatter(this.dateTimeForm.useTime+""),this.useTimeFormatter(this.dateTimeData[i].useTime));
                                }else {
                                    if(this.editapplyDate != this.dateTimeData[i].applyDate || this.useTimeFormatter(this.edituseTime+"") != this.useTimeFormatter(this.dateTimeData[i].useTime)){//不是被修改的这条
                                        if(this.dateTimeForm.applyDate != this.dateTimeData[i].applyDate || this.useTimeFormatter(this.dateTimeForm.useTime+"") != this.useTimeFormatter(this.dateTimeData[i].useTime)){
                                            flag = this.checkTimeRepeat(this.useTimeFormatter(this.dateTimeForm.useTime+""),this.useTimeFormatter(this.dateTimeData[i].useTime));
                                        }
                                    }
                                } */
                                if(this.editTimeType=="add"){
                                    var jc = (this.dateTimeForm.useTime+"").split(",");
                                    for(var c=0;c<jc.length;c++){
                                        if(this.dateTimeData[i].useTime.indexOf(jc[c])>-1){
                                            flag = true;
                                        }
                                    }
                                }else {
                                    if(this.editapplyDate != this.dateTimeData[i].applyDate || (this.edituseTime+"") != this.dateTimeData[i].useTime){//不是被修改的这条
                                        if(this.dateTimeForm.applyDate != this.dateTimeData[i].applyDate || (this.dateTimeForm.useTime+"") != this.dateTimeData[i].useTime){
                                            var jc = (this.dateTimeForm.useTime+"").split(",");
                                            for(var c=0;c<jc.length;c++){
                                                if(this.dateTimeData[i].useTime.indexOf(jc[c])>-1){
                                                    flag = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        if(flag == false){
                            if(this.editTimeType == "add"){
                                this.dateTimeData.push({"applyDate": this.dateTimeForm.applyDate,"useTime":(this.dateTimeForm.useTime+"")});
                            }else{
                                for(let i=0;i<this.dateTimeData.length;i++){
                                    if(this.editapplyDate == this.dateTimeData[i].applyDate && (this.edituseTime+"") == this.dateTimeData[i].useTime){
                                        this.dateTimeData.splice(i,1,{"applyDate": this.dateTimeForm.applyDate,"useTime":(this.dateTimeForm.useTime+"")});
                                    }
                                }
                            }
                            this.handleDateTimeDialogClose();
                        }else{
                            this.$message.error('所选时间有重叠 ，请重新设置!');
                        }
                    }
                });
            },
            checkTimeRepeat(checktime,othertime){
                var flag = false;
                //alert(checktime+"|"+othertime);
                let addtime = checktime.split("-");
                let addtime_start = addtime[0].split(":");
                let addtime_end = addtime[1].split(":");
                let addtime_startmin = parseInt(addtime_start[0],10)*60 + parseInt(addtime_start[1],10);
                let addtime_endmin = parseInt(addtime_end[0],10)*60 + parseInt(addtime_end[1],10);

                let existtime = othertime.split("-");
                let existtime_start = existtime[0].split(":");
                let existtime_end = existtime[1].split(":");
                let existtime_startmin = parseInt(existtime_start[0],10)*60 + parseInt(existtime_start[1],10);
                let existtime_endmin = parseInt(existtime_end[0],10)*60 + parseInt(existtime_end[1],10);

                if(addtime_startmin < existtime_startmin) {
                    if(addtime_endmin < existtime_startmin) {

                    }else if(addtime_endmin >= existtime_startmin) {
                        flag = true;
                    }
                }else if(addtime_startmin == existtime_startmin) {
                    flag = true;
                }else if(addtime_startmin > existtime_startmin) {
                    if(addtime_startmin > existtime_endmin) {

                    }else if(addtime_startmin <= existtime_endmin) {
                        flag = true;
                    }
                }
                //alert("flag：--"+flag);
                return flag;
            },
            handleDateTimeDialogClose(){
                this.dateTimeDialog = false;
                this.dateTimeForm.applyDate = null;
                this.dateTimeForm.useTime = null;
                this.selectRowDateTime = null;
            },
            timeFormatter(row){
                let str = '';
                if(row.useTime.indexOf("#")>-1){
                    let times = row.useTime.split("#");
                    for(var i=0;i<times.length;i++){
                        str += times[i]+",";
                    }
                    if(str!=""){
                        str = str.substring(0,str.length-1);
                    }
                }else{
                    str = row.useTime;
                }
                return str;
            },
            useTimeFormatter(useTime){
                let str = '';
                if(useTime.indexOf("#")>-1){
                    let times = useTime.split("#");
                    for(var i=0;i<times.length;i++){
                        str += times[i]+",";
                    }
                    if(str!=""){
                        str = str.substring(0,str.length-1);
                    }
                }else{
                    str = useTime;
                }
                return str;
            },
            checkDate(){
                let curDate = this.getCurrentFormatDate();
                if(this.dateTimeForm.applyDate < curDate){
                    this.dateTimeForm.applyDate = null;
                    this.$message({
                        title: '提示',
                        message: '申请日期不能小于当前日期,请重新选择！',
                        type: 'warning',
                        duration: 2000,
                    });
                }else{
                    const paramMap = {
                        'Xnxqbm': this.curdForm.xnxqbm,
                        'curDate': this.dateTimeForm.applyDate,
                    }
                    this.$api.teachingSiteManage.teachingSiteApply.checkDate({
                        data: paramMap
                    }).then(response => {
                        let result = response.data.data.result;
                        if(result=="false"){
                            this.dateTimeForm.applyDate = null;
                            this.$message({
                                title: '提示',
                                message: '申请日期不在当前学年学期范围内,请重新选择!',
                                type: 'warning',
                                duration: 2000,
                            });
                        }

                    }).catch(error => {
                        console.log(error);
                    });
                }
            },
            addRec(){
                this.dialogTitle = "新建";
                this.disabled = false;
                this.auditDisabled = false;
                this.dialogVisible = true;
                this.editType = "new";
                this.curdForm.submitState = "0";

                if(this.$refs['curdForm'] !== undefined){
                    this.$refs['curdForm'].resetFields();
                }
            },
            modRec(rowData) {
                this.selectRowData = rowData;
                this.curdForm.id = rowData.id;

                if (this.selectRowData == null) {
                    this.$alert("请先选择一条记录", "提示", {
                        confirmButtonText: "确定",
                        customClass: 'el-message-box-mobile',
                    });
                    return;
                }

                if(this.editType == "audit"){
                    this.dialogTitle = "审核";
                    this.disabled = true;
                }else if(this.editType == "show"){
                    this.dialogTitle = "详情";
                    this.disabled = true;
                }else{
                    this.dialogTitle = "编辑";
                    this.disabled = false;
                    this.auditDisabled = false;
                    this.editType = "edit";
                }

                this.dialogVisible = true;
                this.$nextTick(() => {
                    this.curdForm.id = this.selectRowData.id;
                    this.curdForm.xnxqbm = this.selectRowData.xnxqbm;
                    for(let i=0;i<this.xnxqInfo.length;i++){
                        if(this.curdForm.xnxqbm == this.xnxqInfo[i].comboValue){
                            this.curdForm.xnxqmc = this.xnxqInfo[i].comboName;
                            break;
                        }
                    }
                    this.curdForm.siteCode = this.selectRowData.siteCode;
                    this.curdForm.siteName = this.selectRowData.siteName;
                    this.curdForm.useTime = this.selectRowData.useTime;
                    this.curdForm.useDescription = this.selectRowData.useDescription;
                    this.curdForm.otherRequire = this.selectRowData.otherRequire;
                    this.curdForm.otherRequire = this.selectRowData.otherRequire;
                    this.curdForm.submitState = this.selectRowData.submitState;
                    this.curdForm.auditState = this.selectRowData.auditState;
                    this.curdForm.auditLevel = this.selectRowData.auditLevel;
                    this.curdForm.auditAuth = this.selectRowData.auditAuth;
                    this.$nextTick().then(() => {
                        this.siteOption();
                        this.timeslotOption(this.selectRowData.xnxqbm);
                    });
                    this.siteComboDisable = false;
                    this.siteComboTips = '请选择场地名称';
                    if(this.curdForm.useTime != ''){
                        this.dateTimeData = [];
                        let timeinfo = this.curdForm.useTime.split(",");
                        for(let i=0;i<timeinfo.length;i++){
                            let times = timeinfo[i].split("@");
                            let timeslot = times[1];
                            this.dateTimeData.push({"applyDate": times[0],"useTime": timeslot});
                        }
                    }
                });
            },
            saveRec() {
                this.formSubmiting = true;

                this.$refs['curdForm'].validate((valid) => {
                    if (valid) {
                        if(this.dateTimeData == [] || this.dateTimeData==''){
                            this.$message.error('请设置申请日期和时间');
                        }else{
                            const paramMap = {
                                'Id': this.curdForm.id,
                                'Xnxqbm':this.curdForm.xnxqbm,
                                'SiteCode':this.curdForm.siteCode,
                                'UseDescription':this.curdForm.useDescription,
                                'OtherRequire':this.curdForm.otherRequire,
                                'SubmitState':this.curdForm.submitState,
                                'dateTimeData':JSON.stringify(this.dateTimeData),
                                'type': this.editType,
                            };
                            this.$api.teachingSiteManage.teachingSiteApply.saveApply({
                                data: paramMap,
                            }).then((response) => {
                                let state = response.data.data.state;
                                let msg = response.data.data.msg;

                                if (state == 'Success') {
                                    this.$notify({
                                        title: "成功",
                                        message: msg ? msg : "保存成功",
                                        type: "success",
                                        duration: 1500,
                                    });

                                    if(this.editType=="new" && this.curdForm.id==''){
                                        let bh = response.data.data.bh;
                                        this.curdForm.id = bh;
                                    }
                                    this.currentPage = 1;
                                    this.limit = 10;
                                    this.queryList();
                                    if(this.curdForm.submitState == '1'){
                                        this.dialogVisible = false;
                                    }
                                }else{
                                    this.$notify({
                                        title: "失败",
                                        message: msg ? msg : '保存失败',
                                        type: "error",
                                        duration: 3000,
                                    });
                                }
                            }).catch((error) => {
                                this.$notify({
                                    title: "错误",
                                    message: error,
                                    type: "error",
                                    duration: 3000,
                                });
                            });
                        }
                    } else {
                        return false;
                    }
                });

                this.formSubmiting = false;
            },
            submitRec(){
                confirmMsg('提交后将无法再修改场地设置信息，是否继续？', 'el-message-box-mobile').then(() => {
                    this.curdForm.submitState = '1';
                    this.saveRec();
                });
            },
            delRec(rowData){
                confirmMsg('是否确定要删除该申请？', 'el-message-box-mobile').then(() => {
                    this.curdForm.id = rowData.id;

                    this.$api.teachingSiteManage.teachingSiteApply.delApply({
                        data: this.curdForm,
                    }).then((response) => {
                        let state = response.data.data.state;

                        if (state == 'Success') {
                            this.$notify({
                                title: "成功",
                                message: "删除成功",
                                type: "success",
                                duration: 1500,
                            });

                            this.currentPage = 1;
                            this.limit = 10;
                            this.queryList();
                        }else{
                            this.$notify({
                                title: "失败",
                                message: "删除失败",
                                type: "error",
                                duration: 3000,
                            });
                        }
                    }).catch((error) => {
                        this.$notify({
                            title: "错误",
                            message: error,
                            type: "error",
                            duration: 3000,
                        });
                    });
                });
            },
            closeDialog() {
                this.curdForm.id = '';
                this.curdForm.xnxqbm = '';
                this.curdForm.xnxqmc = '';
                this.curdForm.siteCode = '';
                this.curdForm.siteName = '';
                this.curdForm.useDescription = '';
                this.curdForm.otherRequire = '';
                this.curdForm.submitState = '';
                this.curdForm.auditState = '';
                this.curdForm.auditLevel = '';
                this.disabled = true;
                this.dialogVisible = false;
                this.dateTimeData = [];
                this.editType = null;
                this.siteComboDisable = true;
                this.siteComboTips = '请先选择学年学期';
            },
            showDetailInfo(rowData){
                this.selectRowData = rowData;
                this.detailDialogTitle = '详情';
                this.detailDialogTop = '250px';
                this.editType = "show";
                this.auditDisabled = true;
                this.modRec(rowData);
            },
            //查询审核调用参数
            queryAuditParam(){
                const pageName = this.$route.path.substring(this.$route.path.lastIndexOf("/")+1);

                this.$api.common.audit.auditParam({
                    data: { pageName: pageName },
                }).then((res) => {
                    this.auditParam = res.data.data.auditParam;
                    this.queryForm.itemCode = this.auditParam;
                    this.queryList();
                }).catch((err) => {
                    console.log(err);
                });
            },
            auditRec(rowData){
                this.selectRowData = rowData;
                this.dialogTitle = '审核';
                this.dialogVisible = true;
                //this.auditAreaVisible = true;

                this.xgbh = rowData.id;
                this.auditLevel = rowData.auditLevel;
                this.auditDisabled = true;
                this.editType = "audit";
                this.modRec(rowData);
            },
            auditOption(){
                this.detailDialogTitle = this.numarray[parseInt(this.auditLevel)-1]+'级审核';
                this.detailDialogTop = '250px';
                this.detailDialogVisible = true;
                this.auditAreaVisible = true;
            },
            //审核后回调函数
            auditCallback(auditInfo){
                this.detailDialogVisible = false;
                this.dialogVisible = false;
                if(auditInfo.auditLevel==this.totalLevel && auditInfo.auditState=="1"){//最后一级审核通过
                    this.updateApplyState(auditInfo);
                }else if(auditInfo.auditState=="2"){//审核驳回
                    this.updateApplyState(auditInfo);
                }else{
                    this.queryList();
                }
            },
            //显示审核详情列表
            showAuditList(rowData){
                this.selectRowData = rowData;
                this.auditListDialogVisible = true;
            },
            updateApplyState(auditInfo){
                const paramMap = {
                    'Id': auditInfo.relatedCode,
                    'AuditState': auditInfo.auditState,
                }
                this.$api.teachingSiteManage.teachingSiteApply.updateAuditState({
                    data: paramMap,
                }).then((response) => {
                    this.queryList();
                    let state = response.data.data.state;
                    if(state == 'fail'){
                        this.$notify({
                            title: "失败",
                            message: "执行情况审核状态更新失败",
                            type: "error",
                            duration: 3000,
                        });
                    }
                }).catch((error) => {
                    this.$notify({
                        title: "错误",
                        message: error,
                        type: "error",
                        duration: 3000,
                    });
                });
            },
            getCurrentFormatDate(){
                var date = new Date();
                var seperator1 = "-";
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                var currentdate = year + seperator1 + month + seperator1 + strDate;
                return currentdate;
            },
        },
    };
</script>
<style src="styles/mobile.css"></style>
<style scoped>
    #mobileMode #queryArea {
        height: 90px;
        margin: 10px 0 10px 0;
    }

    #mobileMode #queryDialog {
        top: 150px;
    }

    #mobileMode #mainDialogScroll {
        height: 65vh;
        padding: 10px 20px;
    }

    #mobileMode #loadingTips {
        height: 30px;
        line-height: 30px;
        color: #9d9d9d;
        position: relative;
        bottom: 0;
        text-align: center;
    }

    #mobileMode #listArea .cardText label {
        width: 100px;
        display: inline-block;
    }

    .el-dialog-div{
        height: 60vh;
        overflow: auto;
    }
    .attachmentUpload /deep/ .el-upload-dragger {
        width: 320px;
        height: 240px;
    }
    .maskStyle{
        width:960px;
        overflow:hidden;
        background-color:#ffffff;
        filter:alpha(opacity=60);
        -moz-opacity:0.6;
        opacity: 0.3;
        position:absolute;
        top:0px;
        left:0px;
        z-index:100;
    }
    .xsyjDialog {
        top: 20vh;
    }
    .maskStyle{
        width:100%;
        height:100%;
        overflow:hidden;
        display:none;
        background-color:#000000;
        filter:alpha(opacity=60);
        -moz-opacity:0.6;
        opacity: 0.6;
        position:absolute;
        top:0px;
        left:0px;
        z-index:100;
    }

    .maskFont{
         font-size:16px;
         font-weight:bold;
         color:#ffffff;
         width:230px;
         height:100%;
         position:absolute;
         top:50%;
         left:50%;
         margin-top:-10px;
         margin-left:-90px;
    }
</style>



// WEBPACK FOOTER //
// siteApply.vue?1e320d1c